import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";
import { PageHeading } from "../ecosystem/mybswh";
import { Typography, Card, Grid, Button, LinkCTA, ContentSwitcher } from "../ecosystem";

const AdvanceDirectives = (props) => {
    const [selectedOptions, setSelectedOptions] = useState('English')
    const languageOptions = ["English", "Español"]
    const { proxyName } = Tools.getProxyName();
    const firstMsg = "We want our patients to be prepared for anything—especially the unexpected. Sometimes a serious illness or injury can leave a patient unable to communicate, and families have the burden of making difficult decisions without knowing what their loved one really wants.";
    const secondMsg = "An advance care plan lets you make your medical wishes known ahead of time. Baylor Scott & White Health encourages members to create their plan through an online program called MyDirectives or through printing and completing paper forms. Whichever method you choose, both options are free and can help bring peace of mind to you, your family and caregivers.";
    const paperBasedMsg = "If you prefer to work with paper-based documents, you may download any of the forms linked in both English and Spanish. When you are done filling them out, please upload them to MyDirectives.";
    const serverData = props.serverData;
    const enableAdvanceDirectives = serverData && serverData.enableAdvanceDirectives ? serverData.enableAdvanceDirectives : false;
    const mydirectives = serverData && serverData.advanceDirectivesSSOUrl ? serverData.advanceDirectivesSSOUrl + "?Key=" + props.userToken : "https://mydirectives.com/";
    const siteCollectionDocuments = "https://www.bswhealthplan.com/SiteCollectionDocuments/Member-Info/";
    const dnrForm = "https://www.dshs.texas.gov/emstraumasystems/DNR/pdf/DNR_Form.pdf";

    const log = (addressUrl, label) => {
        logUI("MBHWeb.UI.AdvanceDirectives.Click" + (label ? ("." + label) : ""), new Date(), Tools.getURLPath(), addressUrl);
    }

    const navigateToaddress = (addressUrl, label) => {
        if (typeof window !== 'undefined' && addressUrl) {
            log(addressUrl, label);
            window.open(addressUrl, "_blank");
        }
    }

    return (enableAdvanceDirectives ?
        <Grid className="body-content advanced-directives-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading heading="Advance Care Planning & Advance Directives" proxyName={proxyName} />
                    <div className="row advanced-directives">
                        <div className="col-12 col-lg-6 advanced-directives-message">
                            <Typography type="body-02" tag="div">{firstMsg}</Typography>
                            <Typography type="body-02" tag="div">{secondMsg}</Typography>
                        </div>
                        <div className="col-12 col-lg-5 offset-lg-1">
                            <Card className="advanced-directives-card">
                                <div className="advanced-directives-login">
                                    <div className="advanced-directives-content">
                                        <Typography type="heading-02" color="$color-primary-a4" tag="div">MyDirectives</Typography>
                                        <Typography type="body-02" tag="div">Having a plan is one of the best gifts you can give to your loved ones. Please login to access your account.</Typography>
                                    </div>
                                    <div className="login-btn">
                                        <Button onClick={() => { navigateToaddress(mydirectives, "Login") }}>Log in to MyDirectives</Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                    <div className="row advanced-directives">
                        <div className="col-12">
                            <Card className="advanced-directives-card">
                                <div className="advanced-directives-content">
                                    <div className='advanced-directives-header'>
                                        <Typography type="heading-02" color="$color-primary-a2" tag="div">Paper Based</Typography>

                                    </div>
                                    <Typography type="body-02" tag="div">{paperBasedMsg}</Typography>
                                    <div className="advanced-directives-switcher">
                                        <ContentSwitcher options={languageOptions} onChange={(e) => { setSelectedOptions(e) }} />
                                    </div>
                                    <div className={"advanced-directives-documents" + (selectedOptions !== "English" ? " hide-documents" : "")}>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(siteCollectionDocuments + 'Living-Will.pdf', 'LivingWill') }}>Living Will</Button>
                                        </div>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(siteCollectionDocuments + 'Medical-Power-of-Attorney.pdf', 'MedicalPowerOfAttorney') }}>Medical Power of Attorney</Button>
                                        </div>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(dnrForm, 'OutOfHospital') }}>Out-of-Hospital Do-Not-Resuscitate</Button>
                                        </div>
                                    </div>

                                    <div className={"advanced-directives-documents" + (selectedOptions !== "Español" ? " hide-documents" : "")}>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(siteCollectionDocuments + 'Living-Will-sp.pdf', 'LivingWill.Spanish') }}>Living Will (Spanish)</Button>
                                        </div>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(siteCollectionDocuments + 'Medical-Power-of-Attorney-sp.pdf', 'MedicalPowerOfAttorney.Spanish') }}>Medical Power of Attorney (Spanish)</Button>
                                        </div>
                                        <div className="paper-based-buttons">
                                            <Button fluid="true" variant="secondary" onClick={() => { navigateToaddress(siteCollectionDocuments + 'Out-of-Hospital-DNR-sp.pdf', 'OutOfHospital.Spanish') }}>Out-of-Hospital Do-Not-Resuscitate (Spanish)</Button>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row advanced-directives-resources">
                <div className="col-12 maxWidth-content">
                    <div className='resources-header'>
                        <Typography type="heading-02" color="$color-primary-a2" tag="div">Additional Resources</Typography>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <LinkCTA href={siteCollectionDocuments + 'Advance-Care-Planning-FAQ.pdf'} target="_blank" onClick={() => log(siteCollectionDocuments + 'Advance-Care-Planning-FAQ.pdf', 'AdvancedCarePlanningFAQ')}>Advanced Care Planning FAQ</LinkCTA>
                            <LinkCTA href={siteCollectionDocuments + 'Advance-Care-Planning-FAQ-sp.pdf'} target="_blank" onClick={() => log(siteCollectionDocuments + 'Advance-Care-Planning-FAQ-sp', 'AdvancedCarePlanningFAQ.Spanish')}>Advanced Care Planning FAQ (Spanish)</LinkCTA>
                        </div>
                        <div className="col-12 col-lg-6">
                            <LinkCTA href={siteCollectionDocuments + 'Advance-Care-Planning-Thinking-About-Future.pdf'} target="_blank" onClick={() => log(siteCollectionDocuments + 'Advance-Care-Planning-Thinking-About-Future', 'AdvancedCarePlanningThinkingAboutFuture')}>Advanced Care Planning: Thinking About the Future</LinkCTA>
                            <LinkCTA href={siteCollectionDocuments + 'ACP-Guide-to-Your-Care.pdf'} target="_blank" onClick={() => log(siteCollectionDocuments + 'ACP-Guide-to-Your-Care.pdf', '>AGuideToYourCare')}>A Guide to Your Care</LinkCTA>
                        </div>
                    </div>
                </div>
            </div>
        </Grid> :
        <MyChartContainer mode="acp" title="Advance Directives" serverData={serverData} />);
};

const mapStateToProps = state => {
    return {
        userToken: state.domain.t,
        serverData: state.session.serverData
    };
};

export default connect(mapStateToProps, null)(AdvanceDirectives);